<template>
                        <form class="user" action autocomplete="off" @submit.prevent="noteMsg = null;saveNote(note, job, 'Note', noteSavedMethod, flagForAssigned, notesRef)">
                            <div class="px-2">
                                <div v-if="noteMsg" class="alert alert-success">{{noteMsg}}</div>
                                <div class="form-group row">
                                    <label for="note" v-if="notesRef!=='jobNotes'" class="col-md-3 col-form-label col-form-label-lg text-md-right">Add a new Note for {{named}} #{{job.jobid}}:</label>
                                    <label for="note" v-if="notesRef==='jobNotes'" class="col-md-3 col-form-label col-form-label-lg text-md-right">Add a new Note for {{named}} #{{job.jobid | jobid}}:</label>
                                    <div class="col-md-6">
                                        <textarea placeholder="Enter notes i.e. financial info etc" id="note" class="form-control form-control-lg" name="note" value v-model="note"></textarea>
                                    </div>
                                    <div class="col-md-2 d-flex flex-column align-items-bottom">
                                            <div class="custom-control custom-checkbox">
                                                <input v-model="flagForAssigned" type="checkbox" class="custom-control-input" id="customCheck">
                                                <label class="custom-control-label" style="font-size:14px;" for="customCheck">Flag for Assigned User</label>
                                            </div>
                                        <button style="margin-top:auto" type="submit" id="saveNote" class="btn btn-secondary"><i class="fas fa-fw fa-plus"></i> Save New Note</button>
                                    </div>
                                </div>
                            </div>
                        </form>
</template>

<script>

import saveNoteMixin from "../mixins/saveNotes";


export default {
  name: "JobNote",
  mixins: [saveNoteMixin],
  props: {
    job: Object,
    named: String,
    notesRef: String
  },
  data() {
    return {
            flagForAssigned:false,
            noteMsg:null,
            note:''
    };
  },
  methods: {
    noteSavedMethod(msg){
      const t = this;
      t.note = '';
      t.noteMsg = msg;
      setTimeout(function(){ 
        t.noteMsg = '';
      }, 3000);
    }
  },
  mounted() {

  },
};
</script>